
import { Component } from '@angular/core';

@Component({
    selector: 'app-error-card',
    imports: [],
    templateUrl: './error-card.component.html',
    styleUrls: ['./error-card.component.scss']
})
export class ErrorCardComponent {
}
